@if (navService.isSportVisible("7") | async) {
  <app-next-horse-race />
}
<nav class="highlight-tab" mat-tab-nav-bar [tabPanel]="tabPanel">
  @for (item of navItems; track item) {
    @if (navService.isSportVisible(item.label.toLowerCase(), "header") | async) {
      <a mat-tab-link [routerLink]="item?.path" routerLinkActive #rla="routerLinkActive" [active]="rla?.isActive">
        {{ ((loading$ | async) && isCurrentRoute(item.label) ? "..." : item.label) | translate }}
      </a>
    }
  }
</nav>
<mat-tab-nav-panel #tabPanel>
  <router-outlet></router-outlet>
</mat-tab-nav-panel>
